/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Duration_TitleInputs */

const en_event_warning_duration_title = /** @type {(inputs: Event_Warning_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event duration is invalid`)
};

const fr_event_warning_duration_title = /** @type {(inputs: Event_Warning_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée d'événement invalide`)
};

const de_event_warning_duration_title = /** @type {(inputs: Event_Warning_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereignisdauer ist ungültig.`)
};

const it_event_warning_duration_title = /** @type {(inputs: Event_Warning_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La durata dell'evento non è valida`)
};

const ru_event_warning_duration_title = /** @type {(inputs: Event_Warning_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность события недопустима.`)
};

const es_event_warning_duration_title = /** @type {(inputs: Event_Warning_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La duración del evento no es válida`)
};

const zh_cn2_event_warning_duration_title = /** @type {(inputs: Event_Warning_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件持续时间无效`)
};

const ja_event_warning_duration_title = /** @type {(inputs: Event_Warning_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント期間が無効です`)
};

const hi_event_warning_duration_title = /** @type {(inputs: Event_Warning_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट की अवधि अमान्य है`)
};

const pt_pt2_event_warning_duration_title = /** @type {(inputs: Event_Warning_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A duração do evento é inválida.`)
};

/**
* | output |
* | --- |
* | "Event duration is invalid" |
*
* @param {Event_Warning_Duration_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_duration_title = /** @type {((inputs?: Event_Warning_Duration_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Duration_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_duration_title(inputs)
	if (locale === "de") return de_event_warning_duration_title(inputs)
	if (locale === "it") return it_event_warning_duration_title(inputs)
	if (locale === "ru") return ru_event_warning_duration_title(inputs)
	if (locale === "es") return es_event_warning_duration_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_duration_title(inputs)
	if (locale === "ja") return ja_event_warning_duration_title(inputs)
	if (locale === "hi") return hi_event_warning_duration_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_duration_title(inputs)
	return en_event_warning_duration_title(inputs)
});